import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export function SuccessContent({ email }: { email: string }) {
  return (
    <div className="flex flex-col mt-10 gap-10">
      <h1 className="text-5xl">{t`Check your email`}</h1>

      <p className="leading-6">
        <strong>{t`We sent an email to ${email}. Please verify to continue.`}</strong>
        <ul className="list-disc ml-4 mt-4">
          <li>
            <Trans>
              <strong>Don’t see an email?</strong> Check your Junk folder.
            </Trans>
          </li>
          <li>
            <Trans>
              <strong>Still didn’t get it?</strong> Only people who were directly included{" "}
              <strong>(assigned to or Cc’d)</strong> will receive a verification email. If you were not included, you
              won’t receive one and won’t be able to confirm.
            </Trans>
          </li>
        </ul>
      </p>
      <p>
        <Trans>Having trouble? Contact your system administrator.</Trans>
      </p>
    </div>
  );
}
